export interface Segment {
  text: string;
  mention?: boolean;
  token?: string;
}

const escape = (name: string) => name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const segmentBy = (text: string, pattern: RegExp | null, mark: (match: string) => Partial<Segment>): Segment[] => {
  if (!text) return [];
  if (!pattern) return [{ text }];
  const segments: Segment[] = [];
  let lastIndex = 0;
  for (const match of text.matchAll(pattern)) {
    if (match.index > lastIndex) segments.push({ text: text.slice(lastIndex, match.index) });
    segments.push({ text: match[0], ...mark(match[0]) });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) segments.push({ text: text.slice(lastIndex) });
  return segments;
};

export const segmentMentions = (body: string, users: { full_name: string }[]) =>
  segmentBy(body, users.length ? new RegExp(`@(?:${users.map((user) => escape(user.full_name)).join("|")})`, "g") : null, () => ({
    mention: true,
  }));

export const segmentCardNames = (text: string, cards: { token: string; name?: string | null }[]) => {
  const byName = new Map(cards.filter((card) => card.name).map((card) => [card.name as string, card.token]));
  const names = [...byName.keys()].sort((a, b) => b.length - a.length).map(escape);
  const pattern = names.length ? new RegExp(`(?<![\\w-])(?:${names.join("|")})(?![\\w-])`, "g") : null;
  return segmentBy(text, pattern, (name) => ({ token: byName.get(name) }));
};
